import { Box } from "@mui/material";
import React from "react";
import theme from "src/styles/theme";
import { AddProjectCard } from "../Project/AddProjectCard";
import ProfileProjectCard from "./ProfileProjectCard";

const ProjectsGrid = ({
  canEdit,
  projects,
  localizedPageContent,
  prToOpen,
  isFeedback,
  otc,
}: {
  canEdit: boolean;
  projects: any;
  localizedPageContent: any;
  prToOpen: any;
  isFeedback: any;
  otc: any;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignContent: "flex-start",
        gap: 2,
        pt: 2,
        pb: 2,
        width: "100%",
        [theme.breakpoints.down("sm")]: {
          justifyContent: "space-around",
        },
      }}
    >
      {canEdit && (
        <Box
          sx={{
            height: 365,
            width: 365,
            [theme.breakpoints.down("sm")]: {
              width: "100%",
              height: 200,
            },
          }}
        >
          <AddProjectCard
            projectNum={projects.length}
            localizedPageContent={localizedPageContent}
          />
        </Box>
      )}

      {[...projects].reverse().map((project, i) => (
        <Box
          sx={{
            height: 365,
            width: 365,
            [theme.breakpoints.down("sm")]: {
              width: "100%",
            },
          }}
          key={i}
        >
          <ProfileProjectCard
            project={project}
            prToOpen={prToOpen}
            isFeedback={
              isFeedback &&
              otc === project.feedbackCode &&
              !project.feedbackGiven
            }
          />
        </Box>
      ))}

      {/* <ProfilePromotionalCard /> */}
    </Box>
  );
};

export default ProjectsGrid;
